import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListComponent } from '@app/shared/modules/mobile-badge/components/list/list.component';
import { BadgeComponent } from '@app/shared/modules/mobile-badge/components/list/badge/badge.component';
import { BadgeUrlPipe } from '@app/shared/modules/mobile-badge/pipes/badge-url.pipe';

@NgModule({
  declarations: [ListComponent, BadgeComponent, BadgeUrlPipe],
  imports: [CommonModule],
  exports: [ListComponent],
})
export class MobileBadgeModule {}
